import {types} from '../../types';

const setGetProviderListAction = (payload) => {
    return {
        type: types.provider.SET_PROVIDER_LIST,
        payload,
      }
}

const setGetSearchListAction = (payload) => {
  return {
    type: types.provider.SET_SEARCH_LIST,
    payload
  }
}

export {
  setGetProviderListAction as SetGetProviderListAction,
  setGetSearchListAction as SetGetSearchListAction
}